import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { AlertsService } from '../../../services/alerts.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkflowQueryService } from '../../services/workflow-query.service';
import { UserService } from '../../../services/user.service';
import { ConfigService } from '../../../services/config.service';

/**
 * Component for selecting workflow queries for an editor annotation session.
 */
@Component({
	selector: 'workflow-editor-queries',
	templateUrl: './editor-queries.component.html',
	styleUrl: './editor-queries.component.css'
})
export class EditorQueriesComponent implements OnInit {
	LOCALIZATION: any;

	isParagraphsEnabled: boolean = false;
	isNEREnabled: boolean = false;

	queryData = {
		resultAction: "append",
		searchParagraphs: false,
		query_ids: '',
		query_list_ids: '',
		ner_ids: ''
	}

	constructor(
		private alertsService: AlertsService,
		private workflowQueryService: WorkflowQueryService,
		private userService: UserService,
		private configService: ConfigService,
		private modalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.clearSelections();

		this.isParagraphsEnabled =
			this.configService.getConfig()?.dx?.paragraphs ?
				this.configService.getConfig().dx.paragraphs.enabled : false;

		this.workflowQueryService.isNEREnabled().then(
			(response: any) => {
				this.isNEREnabled = true;
			},
			(err: any) => {
				this.isNEREnabled = false;
			}
		);
	}

	private clearSelections(): void {
		this.workflowQueryService.clearSelectedQueries();
		this.workflowQueryService.clearSelectedQueryLists();
		this.workflowQueryService.clearSelectedNER();
	}

	setMode(mode: string): void {
		this.queryData.resultAction = mode;
	}

	submit(): void {
		/*
		 * Build dirty word search request
		 * @param searchRequest       - The queries, doc uuids and resultAction
		 * searchRequest.resultAction - 'Replace','Append' (replaces or appends results to existing annotations)
		 */
		var selectedQueries = this.workflowQueryService.getSelectedQueries();
		if (selectedQueries.length > 0) {
			this.queryData.query_ids = selectedQueries.toString();
		}
		var selectedQueryLists = this.workflowQueryService.getSelectedQueryLists();
		if (selectedQueryLists.length > 0) {
			this.queryData.query_list_ids = selectedQueryLists.toString();
		}
		var selectedNER = this.workflowQueryService.getSelectedNER();
		if (selectedNER.length > 0) {
			this.queryData.ner_ids = selectedNER.toString();
		}

		this.proceed();
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'workflowQueries',
			queryData: this.queryData
		};

		this.modalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
